import React from 'react';
import LegalLayout, { Section } from '../components/LegalLayout';

const SmsTerms = () => (
  <LegalLayout title="SMS Terms & Conditions" effectiveDate="August 28, 2026">
    <Section title="">
      <p>
        YOVAI And Businesses Using YOVAI Technology May Use SMS/Text Messaging For Operational And Customer Communication Purposes Where Appropriate And Permitted.
      </p>
      <p>
        Messages May Include Appointment Confirmations, Appointment Reminders, Scheduling Information, Follow-Up Messages, Requested Information, Customer-Service Communications, And Other Communications Authorized By The Recipient.
      </p>
      <p>Message Frequency May Vary.</p>
      <p>Message And Data Rates May Apply.</p>
      <p>Consent To Receive Marketing Text Messages, Where Applicable, Is Not A Condition Of Purchase.</p>
      <p>Recipients May Reply <strong>STOP</strong> To Opt Out Of Applicable SMS Communications.</p>
      <p>Recipients May Reply <strong>HELP</strong> For Assistance Where Supported.</p>
      <p>Carriers Are Not Liable For Delayed Or Undelivered Messages.</p>
      <p>
        YOVAI And Businesses Using YOVAI Services Are Responsible For Following Applicable Consent And Messaging Requirements Based On The Nature Of The Communications Being Sent.
      </p>
    </Section>
  </LegalLayout>
);

export default SmsTerms;
